<template>
  <div>
    <div class="row">
      <div class="col-10">
        <NCRBreakdownWidget :filter="filter" :gridHeight="270" />       
      </div>
      <div class="col-2">
        <AnalyticsWidget title="Detailed Reports" subTitle="Click to access the detailed reports" :gridHeight="270">
          <div class="p-2">
            <AnalyticsReportLink href="/analytics/reports/orders/ncrvalue#tab-item-list">NCR Report</AnalyticsReportLink>
          </div>
        </AnalyticsWidget>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <DashboardTabbedContentBox :gridHeight="600" large>
          <template v-slot:tablist>
            <Tab :first="true" tabid="tab-ncr-itemvalue">
              <i class="tabbedbox-tab-icon fas fa-money-check-edit-alt"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Value</div>
                <div class="tabbedbox-tab-subtitle">NCR Item Breakdown</div>
              </div>
            </Tab>
            <Tab tabid="tab-ncr-itemcount">
              <i class="tabbedbox-tab-icon fas fa-clipboard-list-check"></i>
              <div class="tabbedbox-tab-info">
                <div class="tabbedbox-tab-title">Count</div>
                <div class="tabbedbox-tab-subtitle">NCR Item Breakdown</div>
              </div>
            </Tab>
          </template>
          <template v-slot:tabcontent>
            <TabPage :first="true" tabid="tab-ncr-itemvalue" class="tabpage-padding-2">
              <NCROrderChartWidget
                :type="NCROrderChartTypes.ncrItemValue"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedNCRFilter.startDate"
                :endDate="appliedNCRFilter.endDate"
                :showDateFilter="true"
                @updateEditingStartDate="editingNCRFilter.startDate = $event"
                @updateEditingEndDate="editingNCRFilter.endDate = $event"
                @dateApplied="applyNCRFilter"
                @dateReset="resetNCRFilter"
              />
            </TabPage>
            <TabPage tabid="tab-ncr-itemcount" class="tabpage-padding-2">
              <NCROrderChartWidget
                :type="NCROrderChartTypes.ncrItemCount"
                :filter="filter"
                :gridHeight="500"
                :embedded="true"
                :showList="true"
                :dateRangeType="ChartDateRangeTypes.custom"
                :startDate="appliedNCRFilter.startDate"
                :endDate="appliedNCRFilter.endDate"
                :showDateFilter="true"
                @updateEditingStartDate="editingNCRFilter.startDate = $event"
                @updateEditingEndDate="editingNCRFilter.endDate = $event"
                @dateApplied="applyNCRFilter"
                @dateReset="resetNCRFilter"
              />
            </TabPage>
          </template>
        </DashboardTabbedContentBox>
      </div>
    </div>

  </div>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import DashboardTitle from '@/components/dashboard/dashboardTitle'
import DashboardContentBox from '@/components/dashboard/dashboardContentBox'
import DashboardTabbedContentBox from '@/components/dashboard/dashboardTabbedContentBox'
import AnalyticsDashboardHeader from '@/modules/intelligence/components/analyticsDashboardHeader'
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsReportLink from '@/modules/intelligence/components/analyticsReportLink'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'

import NCRBreakdownWidget from '@/modules/intelligence/dashboardWidgets/ncrBreakdownWidget'
import NCROrderChartWidget from '@/modules/intelligence/dashboardWidgets/ncrOrderChartWidget'

import ReportFilterPopover from '@/components/reporting/reportFilterPopover'
import ReportDateRangeSelect from '@/components/reporting/reportDateRangeSelect'

import { ChartDateRangeTypes } from '@/modules/intelligence/types'

export default {
  name: 'AnalyticsNCRDashboard',
  components: {
    DashboardTitle,
    DashboardContentBox,
    DashboardTabbedContentBox,
    AnalyticsDashboardHeader,
    AnalyticsWidget,
    AnalyticsReportLink,
    AnalyticsDashboardValue,
    NCRBreakdownWidget,
    NCROrderChartWidget,
    ReportFilterPopover,
    ReportDateRangeSelect
  },
  props: {
    filter: Object
  },
  data() {
    return {
      defaultNCRFilter: {    
        startDate: moment().local().startOf('month').toDate().toISOString(),
        endDate: moment().local().endOf('month').toDate().toISOString()
      },
      editingNCRFilter: {},
      appliedNCRFilter: {},      
    }
  },
  created() {
    this.ChartDateRangeTypes = ChartDateRangeTypes
    this.NCROrderChartTypes = NCROrderChartWidget.NCROrderChartTypes
  },
  mounted() {
    this.editingNCRFilter = _.clone(this.defaultNCRFilter)
    this.appliedNCRFilter = _.clone(this.defaultNCRFilter)
  },
  beforeDestroy() {
    
  },
  methods: {
    applyNCRFilter() {
      this.appliedNCRFilter = _.clone(this.editingNCRFilter)
    },
    resetNCRFilter() {
      this.editingNCRFilter = _.clone(this.defaultNCRFilter)
      this.appliedNCRFilter = _.clone(this.defaultNCRFilter)
    },
    
  }
  
}
</script>